import React, { useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import Stats from './components/Stats';

const ExamplePage = () => {
  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">Stats</h3>
          </div>
        </Col>
      </Row>
      <Row>
        <Stats />
      </Row>
    </div>
  )
};

export default ExamplePage;
